import { appAxios } from 'api/axios';
import { sendCatchFeedback, sendFeedback } from 'functions/feedback';
import { SavingsHistoryItem } from '../jompvault';
interface SavingsHistoryResponse {
  success: boolean;
  message: string;
  data: SavingsHistoryItem[];
  statusCode: number;
}

export const getTotalSavingsBalance = async (customerId?: string) => {
  if (!customerId) return;

  try {
    const { data } = await appAxios.get(
      `get-total-savings-balance?customerId=${customerId}`
    );
    if (data.success) {
      return data.data;
    }
    return data.message;
  } catch (error) {
    sendCatchFeedback(error);
  }
};
export const getSavingsHistory = async (customerId?: string) => {
  if (!customerId) return;

  try {
    const { data } = await appAxios.get<SavingsHistoryResponse>(
      `get-savings-history?CustomerId=${customerId}`
    );
    if (data.success) {
      return data.data;
    }
  } catch (error) {
    sendCatchFeedback(error);
  }
};
export const getAllSavings = async (customerId: string | undefined) => {
  if (!customerId) return;
  try {
    const { data } = await appAxios.get(
      `get-customer-savings?CustomerId=${customerId}`
    );
    if (data.success) {
      return data.data;
    } else {
      sendFeedback(data.message);
    }
  } catch (error) {
    sendCatchFeedback(error);
  }
};
